export const DEFAULT_ACTIVE_FIELD = 'price';

export const MIN_PRICE = 2500;
export const MAX_PRICE = 60000;
export const MIN_YEAR = 1995;
export const MAX_YEAR = new Date().getFullYear() + 1;
export const STAR_RATINGS = [1, 2, 3, 4, 5];

export const PRICE_SLIDER_STEP = 1000;

export const LIFESTYLE_FILTERS = {
  pPlaterApproved: {
    label: 'P-Plater Approved',
    value: 'pPlaterApproved',
  },
  safeCarsForFamilies: {
    label: 'Safe Cars for Families',
    value: 'safeCarsForFamilies',
  },
};

export const POWER_TYPE_FILTERS = {
  ANY: {
    label: 'All vehicles',
    value: 'Any',
  },
  HYBRID: {
    label: 'Hybrid vehicles',
    value: 'Hybrid',
  },
  ELECTRIC: {
    label: 'Electric vehicles',
    value: 'Electric',
  },
};

export const DEFAULT_FILTER_QUERY_PARAMS = {
  minPrice: MIN_PRICE,
  maxPrice: MAX_PRICE,
  minYear: MIN_YEAR,
  maxYear: MAX_YEAR,
  pPlaterApproved: false,
  safeCarsForFamilies: false,
  makes: [],
  bodyTypes: [],
  starRating: [],
  safetyFeatures: [],
  powerTypes: [],
};
